export enum RuoloUtenteEnum {
  ADMIN = 'ADMIN',
  // OPERATOR = 'OPERATOR',
  // VIEWER = 'VIEWER',
  SOSTA_VISUALIZZATORE = 'SOSTA_VISUALIZZATORE',
  SOSTA_MODIFICA = 'SOSTA_MODIFICA',
  SOSTA_SAP = 'SOSTA_SAP',
  ORDINE_SERVIZIO_VISUALIZZATORE = 'ORDINE_SERVIZIO_VISUALIZZATORE',
  ORDINE_SERVIZIO_MODIFICA = 'ORDINE_SERVIZIO_MODIFICA',
  ORDINE_SERVIZIO_SAP = 'ORDINE_SERVIZIO_SAP',
  NEGOZIO_VISUALIZZATORE = 'NEGOZIO_VISUALIZZATORE',
  NEGOZIO_MODIFICA = 'NEGOZIO_MODIFICA',
  NEGOZIO_SAP = 'NEGOZIO_SAP',
  SICUREZZA_VISUALIZZATORE = 'SICUREZZA_VISUALIZZATORE',
  SICUREZZA_MODIFICA = 'SICUREZZA_MODIFICA',
  ANAGRAFICA = 'ANAGRAFICA',
  DOCUMENTI_DIPENDENTI_VISUALIZZATORE = 'DOCUMENTI_DIPENDENTI_VISUALIZZATORE',
  DOCUMENTI_VARI_VISUALIZZATORE = 'DOCUMENTI_VARI_VISUALIZZATORE',
  REPORT_SICUREZZA = 'REPORT_SICUREZZA',
  VENDITORE = 'VENDITORE',
  VENDITORE_TOTEM = 'VENDITORE_TOTEM',
  VENDITORE_BACKOFFICE = 'VENDITORE_BACKOFFICE',
  CONTROLLORE_ACCESSI = 'CONTROLLORE_ACCESSI',
  SICUREZZA = 'SICUREZZA',
  SICUREZZA_SAP = 'SICUREZZA_SAP',
  OPERAIO = 'OPERAIO',
  REPORT_CAPOTURNO = 'REPORT_CAPOTURNO',
  APPROVATORE_PSC_PRIMO_LIVELLO = 'APPROVATORE_PSC_PRIMO_LIVELLO',
  APPROVATORE_PSC_SECONDO_LIVELLO = 'APPROVATORE_PSC_SECONDO_LIVELLO',
  APPROVATORE_REPORT_SICUREZZA_BANCHINA_RONDA = 'APPROVATORE_REPORT_SICUREZZA_BANCHINA_RONDA',
  APPROVATORE_REPORT_VERIFICA_POSTAZIONE_PRIMO_LIVELLO = 'APPROVATORE_REPORT_VERIFICA_POSTAZIONE_PRIMO_LIVELLO',
  APPROVATORE_REPORT_VERIFICA_POSTAZIONE_SECONDO_LIVELLO = 'APPROVATORE_REPORT_VERIFICA_POSTAZIONE_SECONDO_LIVELLO',
  APPROVATORE_REPORT_CAPOTURNO_PRIMO_LIVELLO = 'APPROVATORE_REPORT_CAPOTURNO_PRIMO_LIVELLO',
  APPROVATORE_REPORT_CAPOTURNO_SECONDO_LIVELLO = 'APPROVATORE_REPORT_CAPOTURNO_SECONDO_LIVELLO',
  SEMIRIMORCHIO_VISUALIZZATORE = 'SEMIRIMORCHIO_VISUALIZZATORE',
  SEMIRIMORCHIO_MODIFICA = 'SEMIRIMORCHIO_MODIFICA',
  SEMIRIMORCHIO_SAP = 'SEMIRIMORCHIO_SAP',
  SEMIRIMORCHIO_INGRESSO_USCITA = 'SEMIRIMORCHIO_INGRESSO_USCITA',
  CONTROLLORE_COORDINATORE_SECURITY = 'CONTROLLORE_COORDINATORE_SECURITY',
  CONTROLLORE_REPORT_CAPOTURNO = 'CONTROLLORE_REPORT_CAPOTURNO',
  CONTROLLORE_RESPONSABILE_POSTAZIONE = 'CONTROLLORE_RESPONSABILE_POSTAZIONE',
  CONTROLLORE_ACCESSI_MOBILE = 'CONTROLLORE_ACCESSI_MOBILE',
  REPORT_SECURITY_TRAGHETTI = 'REPORT_SECURITY_TRAGHETTI',
  CONTROLLORE_BANCHINA = 'CONTROLLORE_BANCHINA',
  CONTROLLORE_TRANSITO_CROCIERE = 'CONTROLLORE_TRANSITO_CROCIERE',
  CONTROLLORE_RX_SN_AR = 'CONTROLLORE_RX_SN_AR',
  CONTROLLORE_SECURITY_PAX_CROCIERA = 'CONTROLLORE_SECURITY_PAX_CROCIERA',
  REPORT_RX_SN_AR = 'REPORT_RX_SN_AR',
  REPORT_CONTROLLO_BANCHINA = 'REPORT_CONTROLLO_BANCHINA',
  REPORT_RESPONSABILE_POSTAZIONE = 'REPORT_RESPONSABILE_POSTAZIONE',
  REPORT_TRANSITO_CROCIERE = 'REPORT_TRANSITO_CROCIERE',
  REPORT_COORDINATORE_SECURITY = 'REPORT_COORDINATORE_SECURITY',
  REPORT_SECURITY_PAX_CROCIERA = 'REPORT_SECURITY_PAX_CROCIERA',
}

export enum OperaioSubRuoliEnum {
  OP_SUPER = 'Op. Supervisore',
  OPERATORE = 'Operatore',
  FACCHINO = 'Facchino'
}

export enum RuoloDipendenteEnum {
  'HOSTESS' = 'Accoglienza',
  'HOSTESS-CT' = 'Accoglienza-CT',
  'COORDINATRICE-HOSTESS' = 'Coordinatrice Accoglienza',
  'GUARDIA GIURATA-CS' = 'Coordinatore di Security',
  'GUARDIA GIURATA-RP' = 'Responsabile Postazione Security',
  'GUARDIA GIURATA' = 'Guardia Giurata',
  'OPERAIO' = 'Operaio',
  'OPERAIO-CT' = 'Operaio Supervisore',
}

export enum SecuritySubRuoliEnum {
  SEC_SUPER = 'Sec. Supervisore',
  SEC_ACCES = 'Sec. Accessi',
  SEC_RX = 'Sec. Rx',
  SEC_USC_TERM = 'Sec. Usc. Terminal',
  SEC_SHIP_CARD = 'Ship Card'
}

export enum HostessSubRuoliEnum {
  HOSTS = 'Shuttle Bus',
  ACCOGLIENZA = 'Accoglienza',
  COGORANO = 'Cogorano'
}

export enum TipoBiglietto {
  BIGLIETTO = 'BIGLIETTO',
  ABBONAMENTO = 'ABBONAMENTO',
  CARNET = 'CARNET',
}

export enum TipoSicurezza {
  BANCHINA = 'BANCHINA',
  PSC_CRO = 'PSC_CRO',
  PSC_CRO_IMB = 'PSC_CRO_IMB',
  PSC_CRO_SBA = 'PSC_CRO_SBA',
  PSC_TRG = 'PSC_TRG',
  PSC_TRG_IMB = 'PSC_TRG_IMB',
  PSC_TRG_SBA = 'PSC_TRG_SBA',
  SEMIRIMORCHI = 'SEMIRIMORCHI',
  RONDA = 'RONDA',
}

export enum StatoSicurezzaAreaPorto {
  DA_APPROVARE = 'DA_APPROVARE',
  APPROVATO = 'APPROVATO',
  APPROVATO_PRIMO_LIVELLO = 'APPROVATO_PRIMO_LIVELLO'
}

export enum TipoDocumentoChiaveEnum {
  DIPENDENTE = 'DIPENDENTE',
  VARI = 'VARI',
}
